const channelPrefix = 'core/publicapi';
export const Channels = {
    METHOD_CALL: `${channelPrefix}:method-call`,
    PUSH_EVENT: `${channelPrefix}:push-event`,
};
